// extracted by mini-css-extract-plugin
export var infoBox = "style-module--infoBox--733b2";
export var infoBox__close = "style-module--infoBox__close--6d17a";
export var infoBox__container = "style-module--infoBox__container--2f92c";
export var infoBox__logo = "style-module--infoBox__logo--9d92d";
export var infoBox__main = "style-module--infoBox__main--72511";
export var infoBox__text = "style-module--infoBox__text--3d55c";